import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import evokeTheme from "../evokeTheme";

const useAppTheme = () => {
  const storedTheme = localStorage.getItem("appTheme");
  const appTheme = useSelector((state) => state.appTheme);
  const isDarkMode = appTheme === "dark" || storedTheme === "dark";
  const themeMode = isDarkMode ? "dark" : "light";

  const [theme, setTheme] = useState(evokeTheme(themeMode));

  const dispatch = useDispatch();

  useEffect(() => {
    setTheme(evokeTheme(themeMode));
    dispatch({ type: "SET_APP_THEME", payload: themeMode });
  }, [dispatch, themeMode]);

  return theme;
};

export default useAppTheme;
